export const PRODUCT_SIDE = 265;
